import React, { useState } from "react";
import { ConfigProvider, Layout, Menu } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  HomeOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  FileTextOutlined,
  VideoCameraOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import "../App.css";

// import logo from "../assets/logo-text.png";

const { Header, Sider, Content } = Layout;

function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const logoutClicked = () => {
    //TODO: api call for token cancellation
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.clear();
    navigate("/login");
  };

  const isAllowed = (allowedRoles) => {
    let user = JSON.parse(localStorage.getItem("user"));
    let userRole = user ? user.role : null;
    let isAllowed = false;
    if (userRole) {
      isAllowed = allowedRoles.find((role) => role == userRole);
    }
    return isAllowed;
  };

  const items = [
    {
      label: "Dashboard",
      path: "dashboard",
      key: "dashboard",
      icon: <HomeOutlined />,
    },
    {
      label: "Grievance",
      path: "admin/grievance",
      key: "grievance",
      permission: ["admin"],
    },
    {
      label: "Video Gallery",
      path: "admin/videos",
      key: "video",
      permission: ["admin"],
      icon: <VideoCameraOutlined />,
    },
    {
      label: "Image Gallery",
      path: "admin/images",
      key: "images",
      permission: ["admin"],
      icon: <FileImageOutlined />,
    },
    {
      label: "Home",
      key: "home",
      icon: <SettingOutlined />,
      permission: ["admin"],
      children: [
        {
          label: "Moving Text",
          path: "admin/moving-text",
          key: "moving-text",
          permission: ["admin"],
        },
        {
          label: "External Links",
          path: "admin/external-link",
          key: "external-link",
          permission: ["admin"],
        },
        {
          label: "Suchana",
          path: "admin/suchana",
          key: "suchana",
          permission: ["admin"],
        },

        {
          label: "Grampanchayati",
          path: "admin/grampanchayati-text",
          key: "grampanchayati-text",
          permission: ["admin"],
        },
        {
          label: "Important Forms",
          path: "admin/important-forms",
          key: "important-forms",
          permission: ["admin"],
        },
      ],
    },
    {
      label: "Padadhikari",
      path: "admin/padadhikari",
      key: "padadhikari",
      permission: ["admin"],
    },
    {
      label: "Adhikari",
      path: "admin/adhikari",
      key: "adhikari",
      permission: ["admin"],
    },

    {
      label: "Log Out",
      key: "logout",
      icon: <LogoutOutlined />,
      onClick: logoutClicked,
    },
  ];

  let href = window.location.href?.split("/");
  href = href.slice(-1);

  return (
    <Layout style={{ minHeight: "100vh" }} className="admin-app-sider">
      <Sider trigger={null} collapsible collapsed={collapsed} theme="dark">
        {/* <div className="logo">
          <img
            style={{ height: 50, width: "100%" }}
            src={logo}
            alt="GPAT Academy"
          />
        </div> */}
        <ConfigProvider
          theme={{
            token: {
              fontSize: 14,
              itemBorderRadius: 16,
            },
          }}
        >
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={href}
            selectedKeys={href}
            items={items.map((l1_item, index) => {
              let return_status = 0;
              if (l1_item?.permission) {
                if (isAllowed(l1_item?.permission)) {
                  return_status = 1;
                }
              } else {
                return_status = 1;
              }
              return (
                return_status && {
                  ...l1_item,
                  label: l1_item?.path ? (
                    <Link to={l1_item?.path}>{l1_item?.label}</Link>
                  ) : (
                    <>{l1_item?.label}</>
                  ),
                  children: l1_item?.children?.map((l2_item, l2_index) => {
                    let return_status = 0;
                    if (l2_item?.permission) {
                      if (isAllowed(l2_item?.permission)) {
                        return_status = 1;
                      }
                    } else {
                      return_status = 1;
                    }
                    return (
                      return_status && {
                        ...l2_item,
                        label: <Link to={l2_item?.path}>{l2_item?.label}</Link>,
                      }
                    );
                  }),
                }
              );
            })}
          ></Menu>
        </ConfigProvider>
      </Sider>
      <Layout
        className="site-layout"
        style={{
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <Header style={{ padding: 0 }}>
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: toggle,
            }
          )}
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 5,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default MainLayout;
